<template>
    <el-select v-bind="$attrs" placeholder="" :clearable="clearable" :filterable="filterable" :value="value" @input="change">
        <template slot="prefix">
            <flag :squared="false" :iso="value.substr(0, 2)" v-if="value"/>
        </template>
        <el-option v-for="(item, index) in options" :key="index" :value="item.id" :label="item.value">
            <span><flag :squared="false" :iso="item.iso"/> {{ item.value }}</span>
        </el-option>
    </el-select>
</template>

<style lang="scss">
    .el-select {
        @apply w-full;
    }
</style>

<script>
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      options: [
        { id: 'ARS', iso: 'AR', value: 'ARS - Argentina' },
        { id: 'BRL', iso: 'BR', value: 'BRL - Brasil' },
        { id: 'CLP', iso: 'CL', value: 'CLP - Chile' },
        { id: 'COP', iso: 'CO', value: 'COP - Colombia' },
        { id: 'CRC', iso: 'CR', value: 'CRC - Costa Rica' },
        { id: 'MXN', iso: 'MX', value: 'MXN - México' },
        { id: 'PEN', iso: 'PE', value: 'PEN - Perú' },
        { id: 'USD', iso: 'US', value: 'USD - Estados Unidos' },
        { id: 'VES', iso: 'VE', value: 'VES - Venezuela' }
      ]
    }
  },
  methods: {
    change (data) {
      this.$emit('input', data)
    }
  }
}
</script>
